import React, { createContext, useContext, useEffect, useState } from 'react';
import fetcher from '../helper/fetcher';

const CrmContext = createContext();

export const CrmProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [user, setUser] = useState(null)
    const [receiver, setReceiver] = useState(null)
    const [roles, setRoles] = useState([])

    useEffect(() => {
        fetcher.get("/crm/auth/valid_user")
            .then((res) => {
                if (res?.data?.success) {
                    const user = res.data.data
                    setUser(user)
                    setIsAuthenticated(true)
                    setRoles([res.data.data.role])
                }
            })
            .catch((err) => {
                setIsAuthenticated(false)
            })
    }, [])

    console.log("roles, ===", user, roles)

    const logout = () => {
        localStorage.clear()
        window.location.href = '/crm/login'
    };

    return (
        <CrmContext.Provider value={{
            isAuthenticated, setIsAuthenticated,
            logout, user, setUser, setReceiver, roles, setRoles,
            receiver
        }}>
            {children}
        </CrmContext.Provider>
    );
};

export const useCrm = () => useContext(CrmContext);
